import { shortenedHashBase62 } from '../../functions/src/util/shortenedHashBase62';

export const shortenUrlFrom = (url: string) => {
  const { origin, pathname, search } = new URL(url);
  const hashedPathname = shortenedHashBase62(`${pathname}${search}`);
  const baseUrl = `${origin}`;
  return `${baseUrl}/s/${hashedPathname}`;
};
